function detectCrmType(): string {
  const host = window.location.hostname.toLowerCase();
  if (host.includes('reclassement')) return 'reclassement';
  return import.meta.env.VITE_CRM_TYPE || 'emploi';
}

export const CRM_TYPE: string = detectCrmType();

export function withCrmType<T extends Record<string, any>>(data: T): T & { crmType: string } {
  return { ...data, crmType: CRM_TYPE };
}

export function isCurrentCrmType(doc: { crmType?: string } | undefined | null): boolean {
  if (!doc) return false;
  if (CRM_TYPE === 'reclassement') return doc.crmType === 'reclassement';
  return !doc.crmType || doc.crmType === CRM_TYPE;
}
